import { usePage } from '@inertiajs/react'
import { FALLBACK_BRAND } from '@/lib/brand'

/**
 * The customer-facing brand name for any signed-in Inertia page.
 *
 * The backend shares `brand` (Rails.configuration.x.brand_name — a constant, 'zewzew') on EVERY
 * Inertia page via an ApplicationController-level `inertia_share` — so no operator, portfolio,
 * claim, account, or billing surface ever hardcodes or leaks the internal "Crown RMS" project
 * name. This hook is the single read point: a page renders `const brand = useBrand()` and drops
 * `{brand}` wherever the product name appears.
 *
 * The strict string-guard mirrors marketing/Landing3.tsx exactly — a non-string / empty / blank
 * prop falls back to FALLBACK_BRAND so the UI never renders `undefined` or an empty label.
 */
export function useBrand(): string {
  const brand = usePage().props.brand
  return typeof brand === 'string' && brand.trim() !== '' ? brand : FALLBACK_BRAND
}
